import BaseNode from '../BaseNode';
import { CATEGORY_COLORS } from '../../../constants';

export default function TelegramNode({ id, data, selected }) {
  const summary = data.chatId ? `Chat: ${data.chatId}` : null;

  return (
    <BaseNode
      id={id}
      selected={selected}
      color={CATEGORY_COLORS.integrations}
      image={data.image || '/images/telegramicon.png'}
      label={data.label}
    >
      <p className="text-xs text-gray-500">{summary || data.description}</p>
    </BaseNode>
  );
}
